import React from "react";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { CmpDatePicker } from "../../../Component/Common/ToolBox/ToolBox";

const HeaderComponent = ({
  status,
  handleLoadBtn = () => {},
  filterObj,
  setFilterObj,
  handlePrint,
  handleExport
}) => {
  // Media Queries for Responsiveness
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleStatusChange = (event) => {
    setFilterObj((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };


  return (
    <div className="stock-detail">
      <Grid
        container
        spacing={2}
      >
        <Grid item xs={12} sm={3} md={2}>
          <Typography>From Date</Typography>
          <CmpDatePicker
            xValue={filterObj?.dateFrom}
            xOnChange={(newValue) =>
              setFilterObj((obj) => ({
                ...obj,
                dateFrom: newValue.$d,
              }))
            }
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <Typography>To Date</Typography>
          <CmpDatePicker
            style={{ width: "100% !important" }}
            xValue={filterObj?.dateTo}
            xOnChange={(newValue) =>
              setFilterObj((obj) => ({
                ...obj,
                dateTo: newValue.$d,
              }))
            }
            xName={"dateTo"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <Typography>Status</Typography>
          <FormControl fullWidth>
            <Select
              value={filterObj?.status}
              name="status"
              onChange={handleStatusChange}
            >
              {status.map((sts) => (
                <MenuItem key={sts} value={sts}>
                  {sts}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          md={6}
          display={"flex"}
          justifyContent={isMobile ? "center" : "flex-end"}
          alignItems={"flex-end"}
          // gap={2}
        >
          <Button
            variant="contained"
            size="small"
            sx={{ mr: 1}}
            onClick={handleLoadBtn}
          >
            load
          </Button>
          <Tooltip title="Export CSV" sx={{ mr: 1}}>
            <IconButton color="primary" onClick={handleExport} size="small">
              <DownloadOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Print">
            <IconButton color="primary" onClick={handlePrint} size="small">
              <PrintOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </div>
  );
};

export default HeaderComponent;
